import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMe } from "@/hooks/use-auth";
import { AuthLoading } from "./auth-loading";

/**
 * Route guard: renders <Outlet /> if the workspace session is valid.
 * Redirects to /login?next=<current> otherwise.
 */
export function RequireAuth() {
  const { data: me, isLoading } = useMe();
  const loc = useLocation();

  if (isLoading) return <AuthLoading />;
  if (!me) {
    const next = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <Outlet />;
}
